/* this file is transformed by vux-loader */
/* eslint-disable */
import _asyncToGenerator from "F:/mobile_v20302/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.splice.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'InductionInfo',
  components: {// UploadImage
  },
  props: {},
  data: function data() {
    return {
      sexShowPicker: false,
      sex: '',
      sexName: '',
      sexColumns: [{
        value: 0,
        text: '男'
      }, {
        value: 1,
        text: '女'
      }],
      personName: '',
      //姓名
      nation: '',
      //民族
      nativePlace: '',
      //籍贯
      education: '',
      educationName: '',
      educationColumns: [{
        value: 0,
        text: '研究生及以上'
      }, {
        value: 1,
        text: '本科'
      }, {
        value: 2,
        text: '高中'
      }, {
        value: 3,
        text: '初中'
      }, {
        value: 4,
        text: '小学'
      }],
      imgArr: [],
      ArchivePhoto: '',
      sourceType: ['album', 'camera'],
      img_src: require('@/assets/face/position_success.png'),
      isWq: false,
      arr: [],
      params: {
        wqImages: '',
        //外勤照片,以逗号分隔，最多四张
        arr: []
      }
    };
  },
  computed: {},
  watch: {
    imgArr: {
      handler: function handler(newArr) {
        var _this2 = this;

        if (newArr) {
          this.arr = [];
          this.params.arr = this.imgArr;
          this.imgArr.forEach(function (item) {
            _this2.arr.push(item.mediaId);
          });
          this.params.wqImages = this.arr.join(',');
        }
      },
      deep: true
    }
  },
  created: function created() {},
  mounted: function mounted() {},
  methods: {
    sexConfirm: function sexConfirm(item) {
      this.sex = item.value;
      this.sexName = item.text;
      this.sexShowPicker = false;
    },
    educationConfirm: function educationConfirm(item) {
      this.education = item.value;
      this.educationName = item.text;
      this.educationShowPicker = false;
    },
    afterRead: function afterRead() {// 此时可以自行将文件上传至服务器
    },
    //上传照片
    takePhoto: function takePhoto() {
      this.chooseImage(1);
    },
    //删除
    delItem: function delItem(index) {
      this.imgArr.splice(index, 1);
      this.params.wqImages = '';
      var arr = [];
      this.imgArr.forEach(function (item) {
        arr.push(item.mediaId);
      });
      this.params.wqImages = arr.join(',');
    },
    chooseImage: function chooseImage(Serial) {
      var _this3 = this;

      this.$utils.Tools.getEnv(function (res) {
        if (res === 0 || res === 1) {
          _this3.wxChooseImage(Serial);
        }
      });
    },
    wxChooseImage: function wxChooseImage() {
      var _this4 = this;

      setTimeout(function () {
        _this4.$utils.WeiXin.wxChooseImage(function (res) {
          if (res.length > 0) {
            _this4.uploadImage(res);
          } // }, 4 - this.imgArr.length)

        }, 1);
      }, 1000);
    },
    showId: function showId(arr, i) {
      var _this = this;

      return new Promise(function (resolve) {
        window.vm.$wechat.uploadImage({
          localId: arr[i],
          // 需要上传的图片的本地ID，由chooseImage接口获得
          isShowProgressTips: 0,
          // 默认为1，显示进度提示
          success: function success(res) {
            var serverId = res.serverId;

            _this.showUrl(serverId);

            i++;

            if (i < arr.length) {
              _this.showId(arr, i);
            }

            resolve();
          }
        });
      });
    },
    showUrl: function showUrl(serverId) {
      var _this5 = this;

      this.$api.Sys.getWxImageUrl(serverId, this.$params.mode).then(function (res) {
        var obj = {
          mediaId: serverId,
          url: res.data
        };

        _this5.imgArr.push(obj);
      });
    },
    uploadImage: function uploadImage(res) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this6.showId(res, 0);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
};